import { useEffect, useState } from "react";
import { api, imageUrl } from "./api";
import { MEDIA_BY_KEY } from "../data/siteMedia";

let cached = null;
let pending = null;
export const loadSiteMedia = (force = false) => {
  if (force) { cached = null; pending = null; }
  if (!pending) {
    pending = api.get("/site-media").then((r) => (cached = r.data || [])).catch(() => (cached = []));
  }
  return pending;
};

export const resolveMedia = (key, overrides = []) => {
  const d = MEDIA_BY_KEY[key];
  const o = overrides.find((x) => x.key === key);
  if (!o) return { ...d, sfeerbeeld: true, custom: false };
  return { src: imageUrl(o.path), srcSet: o.path === d.src ? d.srcSet : undefined, alt: o.alt || d.alt, width: d.width, height: d.height,
    sfeerbeeld: o.sfeerbeeld !== false, badge: d.badge, custom: true };
};

export const useSiteMedia = () => {
  const [overrides, setOverrides] = useState(cached || []);
  useEffect(() => {
    let on = true;
    loadSiteMedia().then((list) => on && setOverrides(list));
    return () => { on = false; };
  }, []);
  return (key) => resolveMedia(key, overrides);
};
